(function () {
  'use strict';

  var LIMIT = 6;
  var cache = {}; // cacheKey -> Promise<string|null>

  function recents() { return window.HillmalayaRecentlyViewed || null; }

  function localizedRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function recommendationsUrl() {
    return (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.product_recommendations_url) || '/recommendations/products';
  }

  // Seed: last add-to-cart product (precedence) -> last viewed product -> null.
  // Delegates to the shared resolver in recently-viewed.js (single source of truth).
  function resolveSeed() {
    var r = recents();
    return (r && r.resolveSeed) ? r.resolveSeed() : null;
  }

  function fetchText(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.ok ? res.text() : null; })
      .catch(function () { return null; });
  }

  function hasItems(html) {
    return !!html && html.indexOf('search__results__item--product') !== -1;
  }

  function fetchNewArrivals() {
    return fetchText(localizedRoot() + 'collections/new-arrivals?view=search-discovery');
  }

  // Promise<string|null> of the strip HTML, cached per seed.
  function getStripHtml() {
    var seed = resolveSeed();
    var key = seed ? ('rec:' + seed) : 'new-arrivals';
    if (cache[key]) return cache[key];

    var p;
    if (seed) {
      var url = recommendationsUrl() + '?section_id=search-discovery&product_id=' + encodeURIComponent(seed) + '&intent=related&limit=' + LIMIT;
      p = fetchText(url).then(function (html) {
        if (hasItems(html)) return html;
        return fetchNewArrivals(); // seed yielded no recommendations -> fall back
      });
    } else {
      p = fetchNewArrivals();
    }
    p = p.then(function (html) { return hasItems(html) ? html : null; });
    cache[key] = p;
    return p;
  }

  function clearCache() { cache = {}; }

  function toEl(formEl) {
    if (!formEl) return null;
    return formEl.jquery ? formEl[0] : formEl;
  }

  function wrapperFor(el) {
    return el && el.querySelector ? el.querySelector('.search__results-wrapper') : null;
  }

  function visibleSearchForms() {
    var forms = document.querySelectorAll('[data-autocomplete-true] form');
    var out = [];
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].offsetParent !== null) out.push(forms[i]); // visible only
    }
    return out;
  }

  function inject(wrapper, html, append) {
    if (!wrapper || !html) return;
    if (append) {
      var existing = wrapper.querySelector('.search__results--discovery');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      var div = document.createElement('div');
      div.innerHTML = html;
      while (div.firstChild) wrapper.appendChild(div.firstChild);
    } else {
      wrapper.innerHTML = html;
    }
    wrapper.style.display = '';
    try {
      if (window.PXUTheme && window.PXUTheme.currencyConverter) window.PXUTheme.currencyConverter.convertCurrencies();
    } catch (e) {}
  }

  // Empty state: strip is the sole content of the wrapper(s).
  function renderEmpty(formEl) {
    var el = toEl(formEl);
    var forms = el ? [el] : visibleSearchForms();
    if (!forms.length) return;
    getStripHtml().then(function (html) {
      if (!html) return;
      for (var i = 0; i < forms.length; i++) {
        // Re-check emptiness at inject time: the strip HTML resolves async, and inject(false) overwrites
        // the wrapper. If the shopper started typing meanwhile, live results are showing — don't clobber them.
        var q = forms[i].querySelector('[data-q], input[name="q"]');
        if (q && q.value.trim()) continue;
        inject(wrapperFor(forms[i]), html, false);
      }
    });
  }

  // Thin results: append strip below real matches when fewer than 3 products.
  function maybeAppend(formEl, productCount) {
    if (productCount >= 3) return;
    var wrapper = wrapperFor(toEl(formEl));
    if (!wrapper) return;
    getStripHtml().then(function (html) { inject(wrapper, html, true); });
  }

  window.HillmalayaSearchDiscovery = {
    renderEmpty: renderEmpty,
    maybeAppend: maybeAppend,
    clearCache: clearCache
  };
})();
